export default __webpack_public_path__ + "static/media/credit-card.e48994c3.svg";